<template>
  <div id="home" v-loading.fullscreen.lock="changeLoading">
    <div style="background-color: white; margin: 1rem 2rem">
      <div class="pos_container_panel">
        <el-form :inline="true" style="padding-top: 1rem">
          <el-row style="">
            <el-col :span="12">
              <el-form-item label="客户名称：">
                <el-input
                  v-model="searchForm.customerName"
                  @click="showClientNamePop"
                  class="searchInput"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" size="default" @click="getTableInfo"
                  >查询</el-button
                >
              </el-form-item>
              <el-form-item>
                <el-button
                  type="primary"
                  size="default"
                  @click="selectGlobalNotify"
                  >查询全局配置</el-button
                >
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-divider class="title-divider"></el-divider>
        <!--table-->
        <el-tabs v-model="activeName">
          <el-tab-pane label="通用" name="first">
            <el-table :data="tableData" border style="width: 100%" @cell-click="cellClick">
              <el-table-column type="index" width="50" align="center"></el-table-column>
              <el-table-column prop="globalNotifyName" label="已有全局通知" align="center"></el-table-column>
              <el-table-column prop="notifyType" label="类型" align="center" v-if="false">
                <template #default="scope">{{notifyTypeName(scope.row.notifyType)}}</template>
              </el-table-column>
              <el-table-column prop="triggerScene" label="触发场景" align="center"></el-table-column>
              <el-table-column prop="receiver" label="邮件接收人" align="center">
                <template #default="scope">{{receiverName(scope.row.receiver)}}</template>
              </el-table-column>
              <el-table-column prop="smsReceiver" label="SMS接收人" align="center">
                <template #default="scope">{{receiverName(scope.row.smsReceiver)}}</template>
              </el-table-column>
              <el-table-column prop="isManual" label="含补单" align="center">
                <template #default="scope">
                  <el-checkbox
                    v-if="
                      scope.$index === 1 ||
                      scope.$index === 4 ||
                      scope.$index === 6 ||
                      scope.$index === 15
                    "
                    v-model="scope.row.isManual"
                    @change="editRow(scope.row, true)"
                  ></el-checkbox>
                  <span v-else></span>
                </template>
              </el-table-column>
              <!-- <el-table-column prop="customerCode" label="企业Code" align="center">
                    <template slot-scope="scope">{{scope.row.customerCode}}</template>
                </el-table-column> -->
              <el-table-column label="状态" width="132" align="center">
                <template #default="scope">
                  <el-button v-if="scope.row.status == 1" type="danger" size="small" @click.prevent="editRow(scope.row, false)">生效中</el-button>
                  <el-button v-if="scope.row.status == 0" type="info" size="small" @click.prevent="editRow(scope.row, false)">关闭</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="后审" name="second" v-if="isOpenLatterApproval">
            <el-table :data="latterApprovalTableData" border style="width: 100%" @cell-click="cellClick">
              <el-table-column type="index" width="50" align="center"></el-table-column>
              <el-table-column prop="globalNotifyName" label="后审已有全局通知" align="center"></el-table-column>
              <el-table-column prop="notifyType" label="类型" align="center" v-if="false">
                <template #default="scope">{{notifyTypeName(scope.row.notifyType)}}</template>
              </el-table-column>
              <el-table-column prop="triggerScene" label="触发场景" align="center"></el-table-column>
              <el-table-column prop="receiver" label="邮件接收人" align="center">
                <template #default="scope">{{receiverName(scope.row.receiver)}}</template>
              </el-table-column>
              <el-table-column prop="smsReceiver" label="SMS接收人" align="center">
                <template #default="scope">{{receiverName(scope.row.smsReceiver)}}</template>
              </el-table-column>
              <el-table-column label="状态" width="132" align="center">
                <template #default="scope">
                  <el-button v-if="scope.row.status == 1" type="danger" size="small" @click.prevent="editRow(scope.row, false)">生效中</el-button>
                  <el-button v-if="scope.row.status == 0" type="info" size="small" @click.prevent="editRow(scope.row, false)">关闭</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <!--修改 类型、接收人绑定 dialog-->
    <el-dialog :title="notifyInfo.title" v-model="notifyInfo.isShow" width="25%">
      <el-form :model="notifyInfo" ref="checkActivityEdit">
        <el-form-item label="类型:" v-if="notifyInfo.showType">
          <el-checkbox-group v-model="notifyInfo.type" style="margin-left: 85px">
            <el-checkbox v-for="item in notifyType" :label="item.key" :key="item.key">{{ item.value }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="接收人:" v-if="!notifyInfo.showType">
          <el-checkbox-group v-model="notifyInfo.receiver" style="margin-left: 85px">
            <el-checkbox v-for="item in receiverType" :label="item.key" :key="item.key">{{ item.value }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button type="primary" @click="editRow(notifyInfo.rowInfo, true)">保存</el-button>
          <el-button @click="notifyCancel()">取 消</el-button>
        </div>
      </template>
    </el-dialog>
    <ConfirmBoxs
      :centerDialogVisible="confirmFlag"
      :confirmMsg="confirmMsg"
      :icon="confirmIcon"
      @setConfirmFlag="setConfirmFlag"
    ></ConfirmBoxs>
    <ClientList
      :customerDialogVisible="clientListFlag"
      @setCustomerFlag="setCustomerFlag"
      @customerInfo="selectClient"
    ></ClientList>
  </div>
</template>
<script>
import { getGlobalNotify, saveGlobalNotify } from "@/api/platformData";
import { ElMessageBox } from 'element-plus'
import ConfirmBoxs from "@/components/confirmBoxs.vue";
import ClientList from "@/components/ClientList.vue";
export default {
  name: "HBEGlobalNotify",
  components: {
    ConfirmBoxs,
    ClientList,
  },
  data() {
    return {
      activeName: "first",
      clientListFlag: false,
      confirmFlag: false,
      confirmMsg: "",
      confirmIcon: "",
      searchForm: {
        customerName: "",
        customerCode: "", //客户编码
        status: "0",
      },
      tableData: [],
      changeLoading: false,
      notifyInfo: {
        isShow: false,
        showType: true,
        title: "",
        type: [],
        receiver: [],
        rowInfo: {},
        smsReceiver: [],
      },
      notifyType: [
        { key: "1", value: "Email" },
        { key: "2", value: "SMS" },
      ],
      receiverType: [
        { id: 1, key: "YD", value: "预订人" },
        { id: 2, key: "LK", value: "入住人" },
        { id: 3, key: "CS", value: "企业抄送邮箱" },
        { id: 4, key: "TX", value: "TX" },
        { id: 5, key: "CC", value: "个人抄送邮箱" },
        { id: 6, key: "JD", value: "酒店" },
        { id: 7, key: "SP", value: "审批人" },
        { id: 8, key: "FPEmail", value: "发票接收邮箱" }
      ],
      isOpenLatterApproval: false,
      latterApprovalTableData: [],
    };
  },
  mounted() {
    this.getTableInfo();
  },
  methods: {
    //confirm
    setConfirmFlag(value) {
      this.confirmFlag = value;
    },
    //搜索点击客户名称弹出选择客户
    showClientNamePop() {
      this.clientListFlag = true;
    },
    //选择客户
    selectClient(item) {
      if (item) {
        this.searchForm.customerCode = item.customerCode;
        this.searchForm.customerName = item.customerName;
      } else {
        this.searchForm.customerCode = "";
        this.searchForm.customerName = "";
      }

      //this.getTableInfo();
    },
    //单元格点击触发事件
    cellClick(row, column) {
      if (row.globalNotifyName !== "送审通知(审批人)") {
        this.receiverType = this.$options.data().receiverType;
        if (column.property == "notifyType") {
          this.notifyInfo.title = "类型";
          this.notifyInfo.rowInfo = row;
          this.notifyInfo.showType = true;
          this.notifyInfo.type = [];
          this.notifyInfo.receiver = [];
          switch (row.notifyType) {
            case 1:
              this.notifyInfo.type.push("1");
              break;
            case 2:
              this.notifyInfo.type.push("2");
              break;
            case 3:
              this.notifyInfo.type.push("1");
              this.notifyInfo.type.push("2");
              break;
          }
          this.notifyInfo.isShow = true;
        }
        if (column.property == "receiver") {
          if (this.activeName == "first") {
            this.receiverType = this.receiverType.filter((item) => {
              return item.id != 7;
            });
          } else {
            this.receiverType = this.$options.data().receiverType;
          }
          this.notifyInfo.title = "邮件接收人";
          this.notifyInfo.rowInfo = row;
          this.notifyInfo.receiver = [];
          this.notifyInfo.type = [];
          this.notifyInfo.receiver = row.receiver.split("|");
          this.notifyInfo.showType = false;
          this.notifyInfo.isShow = true;
        }
        if (column.property == "smsReceiver") {
          if (this.activeName == "first") {
            this.receiverType =
              this.receiverType.length > 2
                ? this.receiverType.slice(0, 2)
                : this.receiverType;
          } else {
            this.receiverType = this.receiverType.filter((item) => {
              return item.id == 1 || item.id == 2 || item.id == 7;
            });
          }
          this.notifyInfo.title = "SMS接收人";
          this.notifyInfo.rowInfo = row;

          this.notifyInfo.receiver = [];
          this.notifyInfo.type = [];
          this.notifyInfo.receiver = row.smsReceiver.split("|");
          this.notifyInfo.showType = false;
          this.notifyInfo.isShow = true;
        }
      }
    },
    setCustomerFlag(value) {
      this.clientListFlag = value;
    },
    getTableInfo() {
      let Param = {
        params: {
          customerCode: this.searchForm.customerCode,
          status: this.searchForm.status,
        },
      };
      getGlobalNotify(Param).then((res) => {
        if (res.code == 200) {
          let $this = this;
          this.tableData = res.data.list.filter(function (item) {
            if ($this.searchForm.customerCode) {
              item.customerCode = $this.searchForm.customerCode;
            }
            return item;
          });
          //this.activeName = "first";
          this.isOpenLatterApproval = res.data.isOpenLatterApproval;
          if (res.data.isOpenLatterApproval) {
            this.latterApprovalTableData = res.data.latterApprovalList;
          }
        } else {
          this.confirmFlag = true;
          this.confirmMsg = "查询失败,请重新尝试";
          return;
        }
      });
    },
    notifyTypeName(id) {
      switch (id) {
        case 1:
          return "Email";
        case 2:
          return "SMS";
        case 3:
          return "Email & SMS";
      }
    },
    receiverName(receiver) {
      return receiver
        .replace("YD", "预订人")
        .replace("LK", "入住人")
        .replace("CS", "CS企业抄送邮箱")
        .replace("CC", "个人抄送邮箱")
        .replace("JD", "酒店")
        .replace("SP", "审批人")
        .replace("FPEmail", "发票接收邮箱");
    },
    editRow(row, isDialog) {
      if (row.customerCode == "ALL" && this.activeName == "first") {
        this.notifyCancel();
        ElMessageBox.confirm("这是全局配置，请确认是否修改？", "提示", {
          confirmButtonText: "是",
          cancelButtonText: "否",
          type: "warning",
        }).then(() => {
          this.editNotifyInfo(row, isDialog);
        }).catch(() => {
        
        });
      } else {
        this.editNotifyInfo(row, isDialog);
      }
    },
    //是否接受弹框取消
    notifyCancel() {
      this.notifyInfo.isShow = false;
    },
    selectGlobalNotify() {
      this.searchForm.customerCode = "";
      this.searchForm.customerName = "";
      this.getTableInfo();
    },
    editNotifyInfo(row, isDialog) {
      // if(isDialog){
      //   if(this.notifyInfo.title == "类型" && this.notifyInfo.type == ""){
      //     this.confirmFlag = true;
      //     this.confirmMsg = "请选择类型！";
      //     return
      //   }
      //   if(this.notifyInfo.title == "接收人" && this.notifyInfo.receiver == ""){
      //     this.confirmFlag = true;
      //     this.confirmMsg = "请选择接收人！";
      //     return
      //   }
      // }
      var status = isDialog ? row.status : row.status == 0 ? 1 : 0;
      var receiver =
        isDialog && this.notifyInfo.title == "邮件接收人"
          ? this.notifyInfo.receiver
              .filter(function (s) {
                return s && s.trim();
              })
              .sort((a, b) => {
                let aid, bid;
                this.receiverType.forEach((item) => {
                  if (item.key == a) aid = item.id;
                  if (item.key == b) bid = item.id;
                });
                return aid - bid;
              })
              .join("|")
          : row.receiver;
      var smsReceiver =
        isDialog && this.notifyInfo.title == "SMS接收人"
          ? this.notifyInfo.receiver
              .filter(function (s) {
                return s && s.trim();
              })
              .sort((a, b) => {
                let aid, bid;
                this.receiverType.forEach((item) => {
                  if (item.key == a) aid = item.id;
                  if (item.key == b) bid = item.id;
                });
                return aid - bid;
              })
              .join("|")
          : row.smsReceiver;
      var notifyType = 1; //(isDialog && this.notifyInfo.type != "") ? (this.notifyInfo.type.length > 1 ? 3 : this.notifyInfo.type.join()) : row.notifyType;
      if (receiver && smsReceiver) {
        notifyType = 3;
      } else if (receiver) {
        notifyType = 1;
      } else if (smsReceiver) {
        notifyType = 2;
      } else {
        this.confirmFlag = true;
        this.confirmMsg = "请选择接收人！";
        return;
      }
      var params = {
        id: row.id,
        customerCode: this.searchForm.customerCode
          ? this.searchForm.customerCode
          : "ALL",
        customerName: this.searchForm.customerName
          ? this.searchForm.customerName
          : "ALL",
        globalNotifyName: row.globalNotifyName,
        notifyType: notifyType,
        triggerScene: row.triggerScene,
        receiver: receiver,
        smsReceiver: smsReceiver,
        serialNo: row.serialNo,
        status: status,
        createdBy: this.$objBaseInfo.loginID,
        updateBy: this.$objBaseInfo.loginID,
        tencentSmsTemplateNo: row.tencentSmsTemplateNo,
        hlthtSmsTemplateNo: row.hlthtSmsTemplateNo,
        emailTemplateNo: row.emailTemplateNo,
        category: row.category,
        isManual: row.isManual,
      };
      saveGlobalNotify(params).then((res) => {
        if (res.code == 200) {
          this.confirmFlag = true;
          this.confirmMsg = "修改成功！";
          this.notifyCancel();
          this.getTableInfo();
        } else {
          this.confirmFlag = true;
          this.confirmMsg = "保存失败，请稍候再试！";
        }
      });
    },
  },
};
</script>
  <style scoped>
.pos_container_panel {
  padding: 0px 8rem 4rem;
  overflow-x: hidden;
}

.searchInput {
  width: 350px;
  height: 32px;
}

.title-divider {
  margin: 1rem 0;
}
</style>
    